import { FC } from 'react';
import { Card, Progress } from '@bphxd/ds-core-react';
import { Spinner } from 'reactstrap';
import { Alert24 } from '@bphxd/ds-core-react/lib/icons';

const KpiCard: FC<{
  title: string;
  subtitle: string;
  completionCount: number;
  totalCount: number;
  loading?: boolean;
  error?: any;
  target?: number;
}> = ({ title, subtitle, completionCount, totalCount, loading, error, target }) => {
  const alert = target && !(Number(calculatePercentage(completionCount, totalCount)) >= target || totalCount === 0);
  return (
    <Card hoverShadow className="h-100">
      <Card.Body className="pt-4 d-flex flex-column">
        <div className="d-flex">
          <div className="flex-grow-1">
            <Card.Title className="mb-4 d-flex align-items-center" tag="h5">
              {title}
              {alert && <Alert24 className="text-danger ms-2" />}
            </Card.Title>
          </div>
        </div>
        {loading && (
          <div className="d-flex justify-content-center align-items-center flex-grow-1">
            <Spinner />
            <span className="visually-hidden">Loading...</span>
          </div>
        )}
        {error && (
          <div className="d-flex justify-content-center align-items-center flex-grow-1">
            <Alert24 title="error" />
          </div>
        )}
        {!loading && !error && (
          <>
            <div className="d-flex mb-3 fs-6">
              <Card.Text className="mb-0">
                {completionCount}/{totalCount}
              </Card.Text>
              <Card.Text className="ms-auto mb-0 opacity-100">
                {totalCount === 0 ? '100%' : `${calculatePercentage(completionCount, totalCount)}%`}
              </Card.Text>
            </div>
            <Progress
              color="brand"
              custom={
                target
                  ? Number(calculatePercentage(completionCount, totalCount)) > target
                    ? undefined
                    : 'bs-red'
                  : undefined
              }
              className="mb-4"
              value={calculatePercentage(completionCount, totalCount)}
              size="md"
            />
            {target && (
              <div className="d-flex mb-3 fs-6">
                <Card.Text className="mb-0">Target = {target}%</Card.Text>
              </div>
            )}
            <Card.Subtitle>{subtitle}</Card.Subtitle>
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export const calculateKpiPercentage = (completionCount: number, totalCount: number) => {
  return totalCount ? (completionCount / totalCount) * 100 : 0;
};

const calculatePercentage = (completionCount: number, totalCount: number) =>
  calculateKpiPercentage(completionCount, totalCount).toFixed(0);

export default KpiCard;
